import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './client/App';
import { Provider } from 'react-redux';
import store from './redux/appState';
import './client/App.css'
import 'antd-css-utilities/utility.min.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ErrorBoundary from './client/components/ErrorBoundary';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

// Suppress MetaMask errors from console (overlay is disabled in craco.config.js)
window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = String(event.reason?.message || event.reason || '');
  const errorStack = String(event.reason?.stack || '');

  if (errorMessage.includes('MetaMask') || errorStack.includes('chrome-extension://')) {
    event.preventDefault();
    console.warn('[Suppressed] Browser extension error');
  }
});

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <App />
      </GoogleOAuthProvider>
    </Provider>
  </ErrorBoundary>
);
